import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    // A snackbar carrying an action has to outlive the reading of it: three
    // seconds is enough to notice a save confirmation, not enough to decide to
    // follow a link. Callers that offer one raise this.
    duration: { type: Number, default: 3000 }
  }

  connect() {
    this.dismissal = setTimeout(() => {
      this.close();
    }, this.durationValue);
  }

  disconnect() {
    clearTimeout(this.dismissal);
  }

  close() {
    clearTimeout(this.dismissal);
    this.element.classList.add('snackbar--closing');
    setTimeout(() => {
      this.element.remove();
    }, 200);
  }
}
